import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CurrencyService from "src/services/CurrencyService";
import { ESTADOS } from "src/utils/PrestamoEnums";
import TablaEstandar, { IColumn, IAction } from "src/components/shared/Tabla";
import { IPrestamo } from "src/utils/interfaces";
import useTable from "src/hooks/useTable";
import { Box, Typography } from "@mui/material";
import TablaOrdenable from "src/components/shared/TablaOrdenable";
import useFetch from "src/hooks/useFetch";
import axios from "axios";
import useSnack from "src/hooks/useSnackbar";
import Aplazar from "../Aplazar";
import Collapsable from "../../Collapsable";
import VisitarHoyModal from "src/components/shared/Modals/VisitarHoyModal";
import { format } from "date-fns";

export default function TableWrapper({
  editing,
  fecha,
  setTotal,
}: {
  editing: boolean;
  fecha;
  setTotal;
}) {
  const { isLoading, data, setData, getData, setIsLoading } = useTable(
    `listas-diario?fecha=${fecha}`
  );

  useEffect(() => {
    setTotal(data ? data?.length : null);
  }, [data]);

  useEffect(() => {
    setData(() => []);
    setIsLoading(() => true);
  }, [fecha]);

  const columns: IColumn<any>[] = [
    {
      property: "prestamo.cliente.alias",
      label: "Alias cliente",
      notSortable: true,
      format(row) {
        return (
          <Typography
            fontWeight={500}
            onClick={() => navigate(`/clientes/${row?.prestamo?.cliente?.id}`)}
            sx={{ ":hover": {
              cursor: 'pointer',
              textDecoration: 'underline'
            } }}
          >
            {row?.prestamo?.cliente?.alias}
          </Typography>
        );
      },
    },
    {
      property: "prestamo.cuotaActual",
      label: "Cuota actual",
      notSortable: true,
    },
    {
      property: "prestamo.valorCuota",
      label: "Valor de la cuota",
      format(row, value) {
        return CurrencyService.formatStatic(value);
      },
    },
    {
      property: "prestamo.cuotasCompletadas",
      label: "Cuotas completadas / Cuotas totales",
      notSortable: true,
      format(row: any) {
        return (
          <>
            {row.prestamo.cuotasCompletadas}/{row.prestamo.cantidadCuotas}
          </>
        );
      },
    },
    {
      property: "prestamo.valorRestanteCuotaActual",
      label: "Restante cuota",
      notSortable: true,
      format(row, value) {
        return CurrencyService.formatStatic(value);
      },
    },
    {
      property: "fechaAplazo",
      label: "Es aplazo?",
      notSortable: true,
      format(row, value) {
        return value ? <b>Sí</b> : 'No'
      }
    }
  ];

  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const [visitarHoyEntity, setVisitarHoyEntity] = useState(null)

  const actions: IAction[] = [
    {
      label: "Visitar hoy",
      onClick: (row) => {
        setOpenVisitarHoy(true);
        setVisitarHoyEntity(row.id)
      },
    },
    {
      label: "Aplazar visita",
      onClick: (row) => {
        setSearchParams({ aplazar: row.id });
      },
    },
    {
      label: "Ver cliente",
      onClick: (row) => {
        navigate(`/clientes/${row.prestamo.clienteId}`);
      },
    },
  ];

  const [openSnackbar] = useSnack();

  const { fetchData: handlePost, response } = useFetch("post");

  const sendArrayMovement = async (arrayMovement) => {
    await handlePost("listas-ordenamiento", arrayMovement);
    if (axios.isAxiosError(response)) {
      openSnackbar(response?.response?.data?.message);
    }
  };

  const refreshTables = () => {
    getData();
  };

  const [openVisitarHoy, setOpenVisitarHoy] = useState<boolean>(false);

  const { fetchData } = useFetch("post", "aplazos-listas", {
    fechaAplazo: format(new Date(), 'yyyy-MM-dd'),
    comentario: null,
    listaId: visitarHoyEntity,
  });

  const handleSubmit = async () => {
    const response: any = await fetchData();
    if (axios.isAxiosError(response)) {
      openSnackbar(response?.response?.data?.message);
    } else {
      openSnackbar(
        `La visita de ${response?.data?.lista?.prestamo?.cliente?.alias} fue agregada a la lista de hoy.`
      );
      setOpenVisitarHoy(false);
    }
  };

  useEffect(() => {
    if(!openVisitarHoy){
      refreshTables()
    }
  }, [openVisitarHoy])

  return (
    <Box paddingBottom={2}>
      <VisitarHoyModal open={openVisitarHoy} setOpen={setOpenVisitarHoy} handleSubmit={handleSubmit} />
      <Aplazar getData={refreshTables} />
      <TablaOrdenable
        collapsable={
          editing ? null : (row) => <Collapsable prestamo={row?.prestamo} />
        }
        isLoading={isLoading}
        rows={data}
        columns={columns}
        actions={editing ? null : actions}
        setterData={setData}
        handleArrayMovement={sendArrayMovement}
        editing={editing}
      />
    </Box>
  );
}
